<template>
  <div class="flex justify-center">
    <div class="w-full sm:max-w-lg p-2">
      <div>
        <base-alert class="mb-4" />
        <slot />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import BaseAlert from '@/components/BaseAlert.vue'

export default defineComponent({
  components: { BaseAlert },
})
</script>
